import { createIntegrationConnectionConfigurationClassMixin } from '../../../connection/configuration/IntegrationConnectionConfigurationMixin';

export interface GlofoxLocationConfigurationValid {
    type: 'VALID';
    branchId: string;
}

export interface GlofoxLocationConfigurationMissing {
    type: 'MISSING_BRANCH_ID';
}

export type GlofoxLocationConfigurationUnion =
    | GlofoxLocationConfigurationMissing
    | GlofoxLocationConfigurationValid;

export class GlofoxLocationConfiguration extends createIntegrationConnectionConfigurationClassMixin<
    GlofoxLocationConfigurationUnion,
    'GLOFOX_LOCATION'
>('GLOFOX_LOCATION') { }
